import {useEffect} from 'react';

/**
 * Si el usuario suelta un archivo 2px AFUERA de una zona de drop, el navegador navega al archivo y
 * se lleva puesta la pantalla entera — el texto a medio escribir, los chips, todo. Es la pérdida
 * de datos más tonta y más frecuente de un dropzone.
 *
 * Extraído del widget de feedback (`FeedbackAttachments`), que lo resolvía inline. Registrarlo
 * desde dos componentes a la vez es inocuo: `preventDefault` es idempotente.
 *
 * ⚠️ **Es un handler a nivel `document`, y cancela TODO drop**, no sólo el de archivos: mientras una
 * pantalla que lo monte esté viva, arrastrar texto seleccionado hacia un `<textarea>` deja de
 * insertarlo. Es un gesto poco frecuente y el intercambio vale la pena (perder un formulario entero
 * por soltar un PDF al lado es mucho peor), pero si algún día molesta, la salida es filtrar por
 * `event.dataTransfer.types.includes('Files')` en vez de sacar el hook.
 */
export function usePreventFileDropNavigation() {
    useEffect(() => {
        const prevent = (event) => event.preventDefault();
        document.addEventListener('dragover', prevent);
        document.addEventListener('drop', prevent);
        return () => {
            document.removeEventListener('dragover', prevent);
            document.removeEventListener('drop', prevent);
        };
    }, []);
}

export default usePreventFileDropNavigation;
